import { ReactElement } from 'react';

import { VisitDiagnosis, VisitLocation } from '@dreryk/egabinet-visit-frontend-api';

import { Scroll } from '@dreryk/react-components';

import { DischargeSummaryForm } from '../DischargeSummaryForm/DischargeSummaryForm';
import { DischargeSummaryFormRouteLeavingGuard } from '../DischargeSummaryForm/DischargeSummaryFormRouteLeavingGuard';
import { VisitDocumentContextProvider } from '../../../../common/visitDocument/VisitDocumentContext';

import { DischargeSummaryPanelLoader } from './DischargeSummaryPanel.loader';
import { DischargeSummarySendAndPrintAction } from './DischargeSummarySendAndPrintAction';

type DischargeSummaryPanelProps = {
   readonly dictionaryValidOn: Date;
   readonly visitId: number;
   readonly patientId: number;
   readonly reopened: boolean;
   readonly visitDiagnoses: VisitDiagnosis[] | undefined;
   readonly visitLocation: VisitLocation;
};

export const DischargeSummaryPanel = (props: DischargeSummaryPanelProps): ReactElement => {
   return (
      <DischargeSummaryPanelLoader visitId={props.visitId}>
         {({ dischargeSummaryDraft }) => (
            <Scroll testId={'dischargeSummary'}>
               <VisitDocumentContextProvider visitId={props.visitId} externalId={undefined}>
                  <DischargeSummaryForm
                     dictionaryValidOn={props.dictionaryValidOn}
                     defaultValues={dischargeSummaryDraft}
                     visitDiagnoses={props.visitDiagnoses}
                     visitLocation={props.visitLocation}
                  >
                     {({ formState, handleSubmitDraft, handleSubmit, reset, trigger }) => (
                        <>
                           <DischargeSummaryFormRouteLeavingGuard
                              visitId={props.visitId}
                              formState={formState}
                              handleSubmitDraft={handleSubmitDraft}
                           />
                           <DischargeSummarySendAndPrintAction
                              visitId={props.visitId}
                              patientId={props.patientId}
                              handleSubmit={handleSubmit}
                              onSuccess={reset}
                              trigger={trigger}
                              visitLocation={props.visitLocation}
                              disabled={props.reopened}
                           />
                        </>
                     )}
                  </DischargeSummaryForm>
               </VisitDocumentContextProvider>
            </Scroll>
         )}
      </DischargeSummaryPanelLoader>
   );
};
